module.exports = __webpack_public_path__ + "e97dc3a793133f32ed2f8bdaa4e211c3.png";